import { P2GGrid } from '@parcel2go/core-ui';
import QuoteFilterSection, { QuoteFilterCheckbox } from './quote-filter-section';

function Filter({
  title,
  options,
  selected,
  onChange,
  dataTestId
}: {
  title?: string;
  options: { type: string; label: string }[];
  selected: (string | undefined)[] | undefined;
  onChange: (value: string) => void;
  dataTestId?: string;
}) {
  return (
    <QuoteFilterSection title={title} dataTestId={dataTestId}>
      <FilterInner onChange={onChange} options={options} selected={selected} />
    </QuoteFilterSection>
  );
}

export function FilterInner({
  options,
  selected,
  onChange
}: {
  title?: string;
  options: { type: string; label: string }[];
  selected: (string | undefined)[] | undefined;
  onChange: (value: string) => void;
  dataTestId?: string;
}) {
  return (
    <P2GGrid container spacing={1} direction="column">
      {options.map((option) => (
        <P2GGrid item key={option.type}>
          <QuoteFilterCheckbox
            disable={false}
            isSelected={!!selected?.includes(option.type)}
            onClick={() => onChange(option.type)}
            label={option.label}
          />
        </P2GGrid>
      ))}
    </P2GGrid>
  );
}

export default Filter;
